import axios from '@/plugins/axios';
import Vue from 'vue';
import VueToastr from '../../plugins/VueToastr';

Vue.use(VueToastr, {
    timeout: 3000
});

const toastrInstance = new Vue();

export const apiRedirectToLawlex = async () => {
    let formData = new FormData();
    const lawlexurl = window.lawlexurl ? JSON.parse(Buffer.from(window.lawlexurl, "base64").toString()) : '';

    formData.append('url', `${lawlexurl.url}/Dashboard`);
    formData.append('module', `NineDots - Lawlex`);
    return axios.post({ endpoint: '/management/ipd/redirectToLawlex', params: formData, options: { headers: { 'X-Requested-With': 'XMLHttpRequest' } } })
        .then((response) => {
            if (response.data.success) {
                window.location.href = response.data.redirect;
            } else {
                throw Error(response.data.error || "Unknown error occurred");
            }
        }).catch((error) => {
            console.error("API Error:", error);

            let errorMessage = "An error occurred";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.error || "An error occurred";
            } else if (error.message) {
                errorMessage = error.message;
            }

            toastrInstance.$toastr.e(errorMessage);
        });
}

export const apiRedirectToEurlex = async () => {
    let formData = new FormData();
    const eurlexurl = window.eurlexurl ? JSON.parse(Buffer.from(window.eurlexurl, "base64").toString()) : '';

    formData.append('url', `${eurlexurl.url}/Dashboard`);
    formData.append('module', `NineDots - Eurlex`);
    return axios.post({ endpoint: '/management/ipd/redirectToEurlex', params: formData, options: { headers: { 'X-Requested-With': 'XMLHttpRequest' } } })
        .then((response) => {
            if (response.data.success) {
                window.location.href = response.data.redirect;
            } else {
                throw Error(response.data.error || "Unknown error occurred");
            }
        }).catch((error) => {
            console.error("API Error:", error);

            let errorMessage = "An error occurred";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.error || "An error occurred";
            } else if (error.message) {
                errorMessage = error.message;
            }

            toastrInstance.$toastr.e(errorMessage);
        });
}

export const apiGetLawlexAddonStatus = async () => {
    return axios.get({ endpoint: '/management/ipd/getLawlexStatus', params: {}, options: { headers: { 'X-Requested-With': 'XMLHttpRequest' } } })
        .then((response) => {
            return response.data.status;
        }).catch(() => {
            console.log("Get lawlex addon status failed!");
        });
}

export const apiAddToIpdLog = async (moduleName, linkClicked) => {
    try {
        let options = {};
        let params = {};
        options = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};
        params = new URLSearchParams();
        params.append('moduleName' , moduleName);
        params.append('linkClicked' , linkClicked);
        const response = await axios.post({
            endpoint: '/management/ipd/addToIpdLog',
            params: params,
            options: options
        });
        if (response.data) {
            return response.data;
        }
    } catch (e) {
        console.log('There has been a problem with your fetch operation:'+ e.message);
    }
}
